module.exports = __webpack_public_path__ + "img/clear.d6bab1eb.svg";